import { TableauService } from '@tableau/tableau.service';
import { HttpErrorResponse } from '@angular/common/http';
import { IGroupList, IGroup } from './group.structure';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { moduleRoutes } from './urlmap';
import { ApplicationHttpClient } from '@base/http-client';
import { ICompany } from '@company/company.structures';
import { ITableauGroup, IErrorResponse } from '@interfaces';
import { ExceptionService } from '@exceptions-service';

@Injectable()
export class GroupService {
  private _mapRoutes = moduleRoutes;
  private _group: IGroup;
  _company: ICompany;

  private groupsState: ITableauGroup[] = [];
  private bsGroupsState = new BehaviorSubject<ITableauGroup[]>(this.groupsState);

  private tableauGroups: ITableauGroup[];
  private bsTableauGroups = new BehaviorSubject<ITableauGroup[]>(this.tableauGroups);

  constructor(
    private http: ApplicationHttpClient,
    private exceptionService: ExceptionService,
    private tableauService: TableauService,
  ) { }

  getGroups(): Observable<IGroupList> {
    return this.http.Get(this._mapRoutes.list);
  }

  getGroup(id: number): Observable<IGroup> {
    return this.http.Get(`${this._mapRoutes.list}${id}/`);
  }

  loadGroups() {
    return this.http.Get(this._mapRoutes.list).pipe(
      map((res: IGroup[]) => {
        console.log('GRUPOS BD', res['results']);
        this.groupsState = res['results'];
        this.bsGroupsState.next(this.groupsState);
        return res['results'];
      },
      (err: HttpErrorResponse) => {
        console.log('ERROR GRUPOS BD', JSON.stringify(err));
        const error: IErrorResponse = this.exceptionService.errorHandling(err);
      })
    );
  }

  synchronizeTableau() {
    return this.http.Get(this._mapRoutes.sync).pipe(
      map((res: IGroup[]) => {
        this.loadGroups();
        this.tableauGroups = res;
        this.bsTableauGroups.next(this.tableauGroups);
        return res;
      },
      (err: HttpErrorResponse) => {
        console.log('ERROR GRUPOS ', err);
        const error: IErrorResponse = this.exceptionService.errorHandling(err);
      })
    );
  }

  createGroup(group: IGroup): Observable<IGroup> {
    return this.http.Post(this._mapRoutes.create, group);
  }

  updateGroup(group: IGroup): Observable<any> {
    return this.http.Put(`${this._mapRoutes.list}${group.id}/`, group);
  }

  deleteGroup(group: IGroup): Observable<any> {
    return this.http.Delete(`${this._mapRoutes.list}${group.id}/`);
  }

  get group(): IGroup {
    return this._group;
  }

  set group(group: IGroup) {
    this._group = group;
  }

  get company(): ICompany {
    return this._company;
  }

  set company(company: ICompany) {
    this._company = company;
  }

  getMultiples(payload: object): Observable<IGroup[]> {
    return this.http.Post(`${this._mapRoutes.getMultiples}`, payload);
  }

  observeGroups(): Observable<ITableauGroup[]> {
    return this.bsGroupsState.asObservable();
  }
}
